import { ApiError } from 'shared/api/apiError'
import { isAxiosError } from 'shared/api/isAxiosError'

const statusOf = (error: unknown) => (isAxiosError(error) ? error.response?.status : undefined)

export const isNewsPostGone = (error: unknown) => statusOf(error) === 404

export function newsErrorMessage(apiError: ApiError): string {
  if (apiError.reason === 'clientError' && apiError.status === 400) {
    return 'news.errorInvalid'
  }
  if (apiError.reason === 'forbidden') {
    return 'news.errorForbidden'
  }
  if (apiError.reason === 'notFound') {
    return 'news.errorNotFound'
  }

  return 'news.errorGeneric'
}
